import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ContentListResponseDto } from 'src/app/shared/dtos/content-list.dto';
import { transformAndValidatePipe } from 'src/app/shared/utils/operators';
import { Router } from '@angular/router';
import { datadogLogs } from '@datadog/browser-logs';

@Injectable({
  providedIn: 'root'
})
export class ContentListService {
  http = inject(HttpClient);
  router = inject(Router);

  getContentList(): Observable<ContentListResponseDto | null> {
    return this.http.get<ContentListResponseDto>(`/api/content-list`).pipe(
      transformAndValidatePipe(ContentListResponseDto),
      catchError((error: Error) => {
        datadogLogs.logger.error('Error fetching content list:', {}, error);

        if (error instanceof HttpErrorResponse) {
          if (error.status === 401 || error.status === 403) {
            void this.router.navigate(['/unauthorised']);
          }
        }

        return of(null);
      })
    );
  }
}
